const isUrl = (value) => {
	if (value.includes('http')) {
		return true;
	} else {
		return false;
	}
};

export default isUrl;
